import { Box, Skeleton, Stack } from "@mui/material";
import React from "react";

const KeyInformationSkeleton = () => (
  <Box
    className="fluid-box anchor-section"
    sx={{ padding: { xs: "24px", md: "40px" }, paddingRight: {xs: "48px", md: "80px"} }}
    id="key-information"
  >
    {/* Header Skeleton */}
    <Box sx={{ maxWidth: "610px", margin: "0 auto", textAlign: "center", mb: 3 }}>
      <Skeleton
        variant="text"
        width="80%"
        sx={{ 
          margin: "0 auto", 
          mb: 1.5,
          height: { xs: 34, sm: 36 } // Matches responsive font sizes
        }}
      />
      <Skeleton
        variant="text"
        width="100%"
        height={27}
        sx={{ mb: 0.5 }}
      />
      <Skeleton
        variant="text"
        width="90%"
        height={27}
        sx={{ margin: "0 auto" }}
      />
      <Skeleton
        variant="text"
        width="50%"
        height={27}
        sx={{ margin: "0 auto" }}
      />
    </Box>

    {/* FAQ Section Skeleton */}
    <Stack sx={{ padding: "3.75rem 0", gap: "2.5rem" }}>
      {/* Section Header */}
      <Skeleton
        variant="text"
        sx={{ 
          width: { xs: "50%", sm: "40%", md: "30%" },
          height: 42,
          margin: "0 auto", 
          pb: 1.5
        }}
      />
      
      {/* FAQ Container */}
      <Box
        sx={{
          maxWidth: "700px",
          margin: "0 auto",
          width: "100%"
        }}
      >
        {/* Expand All Button */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
          <Skeleton variant="text" width={100} height={32} />
        </Box>

        {/* FAQ Items */}
        {[1, 2, 3, 4].map((item) => (
          <Box
            key={item}
            sx={{
              borderBottom: (theme) => item !== 4 ? `1px solid ${theme.palette.divider}` : "none",
              py: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2
            }}
          >
            <Skeleton variant="text" width="85%" height={24} />
            <Skeleton variant="circular" width={24} height={24} />
          </Box>
        ))}
      </Box>
    </Stack>
  </Box>
);

export default KeyInformationSkeleton;
